import { createFileRoute } from "@tanstack/react-router"
import { GeneralSettingsPage } from "~/components/settings/GeneralSettingsPage"

export const Route = createFileRoute("/_auth/settings/_layout/general")({
  component: GeneralSettingsPage,
})
